export default [
{d:"0101",t:"Genesis 1-3",u:"https://www.bible.com/bible/59/GEN.1"},
{d:"0102",t:"Genesis 4-7",u:"https://www.bible.com/bible/59/GEN.4"},
{d:"0103",t:"Genesis 8-11",u:"https://www.bible.com/bible/59/GEN.8"},
{d:"0104",t:"Job 1-5",u:"https://www.bible.com/bible/59/JOB.1"},
{d:"0105",t:"Job 6-9",u:"https://www.bible.com/bible/59/JOB.6"},
{d:"0106",t:"Job 10-13",u:"https://www.bible.com/bible/59/JOB.10"},
{d:"0107",t:"Job 14-16",u:"https://www.bible.com/bible/59/JOB.14"},
{d:"0108",t:"Job 17-20",u:"https://www.bible.com/bible/59/JOB.17"},
{d:"0109",t:"Job 21-23",u:"https://www.bible.com/bible/59/JOB.21"},
{d:"0110",t:"Job 24-28",u:"https://www.bible.com/bible/59/JOB.24"},
{d:"0111",t:"Job 29-31",u:"https://www.bible.com/bible/59/JOB.29"},
{d:"0112",t:"Job 32-34",u:"https://www.bible.com/bible/59/JOB.32"},
{d:"0113",t:"Job 35-37",u:"https://www.bible.com/bible/59/JOB.35"},
{d:"0114",t:"Job 38-39",u:"https://www.bible.com/bible/59/JOB.38"},
{d:"0115",t:"Job 40-42",u:"https://www.bible.com/bible/59/JOB.40"},
{d:"0116",t:"Genesis 12-15",u:"https://www.bible.com/bible/59/GEN.12"},
{d:"0117",t:"Genesis 16-18",u:"https://www.bible.com/bible/59/GEN.16"},
{d:"0118",t:"Genesis 19-21",u:"https://www.bible.com/bible/59/GEN.19"},
{d:"0119",t:"Genesis 22-24",u:"https://www.bible.com/bible/59/GEN.22"},
{d:"0120",t:"Genesis 25-26",u:"https://www.bible.com/bible/59/GEN.25"},
{d:"0121",t:"Genesis 27-29",u:"https://www.bible.com/bible/59/GEN.27"},
{d:"0122",t:"Genesis 30-31",u:"https://www.bible.com/bible/59/GEN.30"},
{d:"0123",t:"Genesis 32-34",u:"https://www.bible.com/bible/59/GEN.32"},
{d:"0124",t:"Genesis 35-37",u:"https://www.bible.com/bible/59/GEN.35"},
{d:"0125",t:"Genesis 38-40",u:"https://www.bible.com/bible/59/GEN.38"},
{d:"0126",t:"Genesis 41-42",u:"https://www.bible.com/bible/59/GEN.41"},
{d:"0127",t:"Genesis 43-45",u:"https://www.bible.com/bible/59/GEN.43"},
{d:"0128",t:"Genesis 46-47",u:"https://www.bible.com/bible/59/GEN.46"},
{d:"0129",t:"Genesis 48-50",u:"https://www.bible.com/bible/59/GEN.48"},
{d:"0130",t:"Exodus 1-3",u:"https://www.bible.com/bible/59/EXO.1"},
{d:"0131",t:"Exodus 4-6",u:"https://www.bible.com/bible/59/EXO.4"},
{d:"0201",t:"Exodus 7-9",u:"https://www.bible.com/bible/59/EXO.7"},
{d:"0202",t:"Exodus 10-12",u:"https://www.bible.com/bible/59/EXO.10"},
{d:"0203",t:"Exodus 13-15",u:"https://www.bible.com/bible/59/EXO.13"},
{d:"0204",t:"Exodus 16-18",u:"https://www.bible.com/bible/59/EXO.16"},
{d:"0205",t:"Exodus 19-21",u:"https://www.bible.com/bible/59/EXO.19"},
{d:"0206",t:"Exodus 22-24",u:"https://www.bible.com/bible/59/EXO.22"},
{d:"0207",t:"Exodus 25-27",u:"https://www.bible.com/bible/59/EXO.25"},
{d:"0208",t:"Exodus 28-29",u:"https://www.bible.com/bible/59/EXO.28"},
{d:"0209",t:"Exodus 30-32",u:"https://www.bible.com/bible/59/EXO.30"},
{d:"0210",t:"Exodus 33-35",u:"https://www.bible.com/bible/59/EXO.33"},
{d:"0211",t:"Exodus 36-38",u:"https://www.bible.com/bible/59/EXO.36"},
{d:"0212",t:"Exodus 39-40",u:"https://www.bible.com/bible/59/EXO.39"},
{d:"0213",t:"Leviticus 1-4",u:"https://www.bible.com/bible/59/LEV.1"},
{d:"0214",t:"Leviticus 5-7",u:"https://www.bible.com/bible/59/LEV.5"},
{d:"0215",t:"Leviticus 8-10",u:"https://www.bible.com/bible/59/LEV.8"},
{d:"0216",t:"Leviticus 11-13",u:"https://www.bible.com/bible/59/LEV.11"},
{d:"0217",t:"Leviticus 14-15",u:"https://www.bible.com/bible/59/LEV.14"},
{d:"0218",t:"Leviticus 16-18",u:"https://www.bible.com/bible/59/LEV.16"},
{d:"0219",t:"Leviticus 19-21",u:"https://www.bible.com/bible/59/LEV.19"},
{d:"0220",t:"Leviticus 22-23",u:"https://www.bible.com/bible/59/LEV.22"},
{d:"0221",t:"Leviticus 24-25",u:"https://www.bible.com/bible/59/LEV.24"},
{d:"0222",t:"Leviticus 26-27",u:"https://www.bible.com/bible/59/LEV.26"},
{d:"0223",t:"Numbers 1-2",u:"https://www.bible.com/bible/59/NUM.1"},
{d:"0224",t:"Numbers 3-4",u:"https://www.bible.com/bible/59/NUM.3"},
{d:"0225",t:"Numbers 5-6",u:"https://www.bible.com/bible/59/NUM.5"},
{d:"0226",t:"Numbers 7",u:"https://www.bible.com/bible/59/NUM.7"},
{d:"0227",t:"Numbers 8-10",u:"https://www.bible.com/bible/59/NUM.8"},
{d:"0228",t:"Numbers 11-13",u:"https://www.bible.com/bible/59/NUM.11"},
{d:"0301",t:"Numbers 14-15",u:"https://www.bible.com/bible/59/NUM.14"},
{d:"0301",t:"Psalms 90",u:"https://www.bible.com/bible/59/PSA.90"},
{d:"0302",t:"Numbers 16-17",u:"https://www.bible.com/bible/59/NUM.16"},
{d:"0303",t:"Numbers 18-20",u:"https://www.bible.com/bible/59/NUM.18"},
{d:"0304",t:"Numbers 21-22",u:"https://www.bible.com/bible/59/NUM.21"},
{d:"0305",t:"Numbers 23-25",u:"https://www.bible.com/bible/59/NUM.23"},
{d:"0306",t:"Numbers 26-27",u:"https://www.bible.com/bible/59/NUM.26"},
{d:"0307",t:"Numbers 28-30",u:"https://www.bible.com/bible/59/NUM.28"},
{d:"0308",t:"Numbers 31-32",u:"https://www.bible.com/bible/59/NUM.31"},
{d:"0309",t:"Numbers 33-34",u:"https://www.bible.com/bible/59/NUM.33"},
{d:"0310",t:"Numbers 35-36",u:"https://www.bible.com/bible/59/NUM.35"},
{d:"0311",t:"Deuteronomy 1-2",u:"https://www.bible.com/bible/59/DEU.1"},
{d:"0312",t:"Deuteronomy 3-4",u:"https://www.bible.com/bible/59/DEU.3"},
{d:"0313",t:"Deuteronomy 5-7",u:"https://www.bible.com/bible/59/DEU.5"},
{d:"0314",t:"Deuteronomy 8-10",u:"https://www.bible.com/bible/59/DEU.8"},
{d:"0315",t:"Deuteronomy 11-13",u:"https://www.bible.com/bible/59/DEU.11"},
{d:"0316",t:"Deuteronomy 14-16",u:"https://www.bible.com/bible/59/DEU.14"},
{d:"0317",t:"Deuteronomy 17-20",u:"https://www.bible.com/bible/59/DEU.17"},
{d:"0318",t:"Deuteronomy 21-23",u:"https://www.bible.com/bible/59/DEU.21"},
{d:"0319",t:"Deuteronomy 24-27",u:"https://www.bible.com/bible/59/DEU.24"},
{d:"0320",t:"Deuteronomy 28-29",u:"https://www.bible.com/bible/59/DEU.28"},
{d:"0321",t:"Deuteronomy 30-31",u:"https://www.bible.com/bible/59/DEU.30"},
{d:"0322",t:"Deuteronomy 32-34",u:"https://www.bible.com/bible/59/DEU.32"},
{d:"0322",t:"Psalms 91",u:"https://www.bible.com/bible/59/PSA.91"},
{d:"0323",t:"Joshua 1-4",u:"https://www.bible.com/bible/59/JOS.1"},
{d:"0324",t:"Joshua 5-8",u:"https://www.bible.com/bible/59/JOS.5"},
{d:"0325",t:"Joshua 9-11",u:"https://www.bible.com/bible/59/JOS.9"},
{d:"0326",t:"Joshua 12-15",u:"https://www.bible.com/bible/59/JOS.12"},
{d:"0327",t:"Joshua 16-18",u:"https://www.bible.com/bible/59/JOS.16"},
{d:"0328",t:"Joshua 19-21",u:"https://www.bible.com/bible/59/JOS.19"},
{d:"0329",t:"Joshua 22-24",u:"https://www.bible.com/bible/59/JOS.22"},
{d:"0330",t:"Judges 1-2",u:"https://www.bible.com/bible/59/JDG.1"},
{d:"0331",t:"Judges 3-5",u:"https://www.bible.com/bible/59/JDG.3"},
{d:"0401",t:"Judges 6-7",u:"https://www.bible.com/bible/59/JDG.6"},
{d:"0402",t:"Judges 8-9",u:"https://www.bible.com/bible/59/JDG.8"},
{d:"0403",t:"Judges 10-12",u:"https://www.bible.com/bible/59/JDG.10"},
{d:"0404",t:"Judges 13-15",u:"https://www.bible.com/bible/59/JDG.13"},
{d:"0405",t:"Judges 16-18",u:"https://www.bible.com/bible/59/JDG.16"},
{d:"0406",t:"Judges 19-21",u:"https://www.bible.com/bible/59/JDG.19"},
{d:"0407",t:"Ruth 1-4",u:"https://www.bible.com/bible/59/RUT.1"},
{d:"0408",t:"1 Samuel 1-3",u:"https://www.bible.com/bible/59/1SA.1"},
{d:"0409",t:"1 Samuel 4-8",u:"https://www.bible.com/bible/59/1SA.4"},
{d:"0410",t:"1 Samuel 9-12",u:"https://www.bible.com/bible/59/1SA.9"},
{d:"0411",t:"1 Samuel 13-14",u:"https://www.bible.com/bible/59/1SA.13"},
{d:"0412",t:"1 Samuel 15-17",u:"https://www.bible.com/bible/59/1SA.15"},
{d:"0413",t:"1 Samuel 18-20",u:"https://www.bible.com/bible/59/1SA.18"},
{d:"0413",t:"Psalms 11",u:"https://www.bible.com/bible/59/PSA.11"},
{d:"0413",t:"Psalms 59",u:"https://www.bible.com/bible/59/PSA.59"},
{d:"0414",t:"1 Samuel 21-24",u:"https://www.bible.com/bible/59/1SA.21"},
{d:"0415",t:"Psalms 7",u:"https://www.bible.com/bible/59/PSA.7"},
{d:"0415",t:"Psalms 27",u:"https://www.bible.com/bible/59/PSA.27"},
{d:"0415",t:"Psalms 31",u:"https://www.bible.com/bible/59/PSA.31"},
{d:"0415",t:"Psalms 34",u:"https://www.bible.com/bible/59/PSA.34"},
{d:"0415",t:"Psalms 52",u:"https://www.bible.com/bible/59/PSA.52"},
{d:"0416",t:"Psalms 56",u:"https://www.bible.com/bible/59/PSA.56"},
{d:"0416",t:"Psalms 120",u:"https://www.bible.com/bible/59/PSA.120"},
{d:"0416",t:"Psalms 140-142",u:"https://www.bible.com/bible/59/PSA.140"},
{d:"0417",t:"1 Samuel 25-27",u:"https://www.bible.com/bible/59/1SA.25"},
{d:"0418",t:"Psalms 17",u:"https://www.bible.com/bible/59/PSA.17"},
{d:"0418",t:"Psalms 35",u:"https://www.bible.com/bible/59/PSA.35"},
{d:"0418",t:"Psalms 54",u:"https://www.bible.com/bible/59/PSA.54"},
{d:"0418",t:"Psalms 63",u:"https://www.bible.com/bible/59/PSA.63"},
{d:"0419",t:"1 Samuel 28-31",u:"https://www.bible.com/bible/59/1SA.28"},
{d:"0419",t:"Psalms 18",u:"https://www.bible.com/bible/59/PSA.18"},
{d:"0420",t:"Psalms 121",u:"https://www.bible.com/bible/59/PSA.121"},
{d:"0420",t:"Psalms 123-125",u:"https://www.bible.com/bible/59/PSA.123"},
{d:"0420",t:"Psalms 128-130",u:"https://www.bible.com/bible/59/PSA.128"},
{d:"0421",t:"2 Samuel 1-4",u:"https://www.bible.com/bible/59/2SA.1"},
{d:"0422",t:"Psalms 6",u:"https://www.bible.com/bible/59/PSA.6"},
{d:"0422",t:"Psalms 8-10",u:"https://www.bible.com/bible/59/PSA.8"},
{d:"0422",t:"Psalms 14",u:"https://www.bible.com/bible/59/PSA.14"},
{d:"0422",t:"Psalms 16",u:"https://www.bible.com/bible/59/PSA.16"},
{d:"0422",t:"Psalms 19",u:"https://www.bible.com/bible/59/PSA.19"},
{d:"0422",t:"Psalms 21",u:"https://www.bible.com/bible/59/PSA.21"},
{d:"0423",t:"Psalms 43-45",u:"https://www.bible.com/bible/59/PSA.43"},
{d:"0423",t:"Psalms 49",u:"https://www.bible.com/bible/59/PSA.49"},
{d:"0423",t:"Psalms 84-85",u:"https://www.bible.com/bible/59/PSA.84"},
{d:"0423",t:"Psalms 87",u:"https://www.bible.com/bible/59/PSA.87"},
{d:"0424",t:"Psalms 73",u:"https://www.bible.com/bible/59/PSA.73"},
{d:"0424",t:"Psalms 77-78",u:"https://www.bible.com/bible/59/PSA.77"},
{d:"0425",t:"Psalms 81",u:"https://www.bible.com/bible/59/PSA.81"},
{d:"0425",t:"Psalms 88",u:"https://www.bible.com/bible/59/PSA.88"},
{d:"0425",t:"Psalms 92-93",u:"https://www.bible.com/bible/59/PSA.92"},
{d:"0426",t:"Psalms 102-104",u:"https://www.bible.com/bible/59/PSA.102"},
{d:"0427",t:"2 Samuel 5-6",u:"https://www.bible.com/bible/59/2SA.5"},
{d:"0427",t:"Psalms 133",u:"https://www.bible.com/bible/59/PSA.133"},
{d:"0428",t:"Psalms 106-107",u:"https://www.bible.com/bible/59/PSA.106"},
{d:"0429",t:"Psalms 1-2",u:"https://www.bible.com/bible/59/PSA.1"},
{d:"0429",t:"Psalms 15",u:"https://www.bible.com/bible/59/PSA.15"},
{d:"0429",t:"Psalms 22-24",u:"https://www.bible.com/bible/59/PSA.22"},
{d:"0429",t:"Psalms 47",u:"https://www.bible.com/bible/59/PSA.47"},
{d:"0429",t:"Psalms 68",u:"https://www.bible.com/bible/59/PSA.68"},
{d:"0430",t:"Psalms 89",u:"https://www.bible.com/bible/59/PSA.89"},
{d:"0430",t:"Psalms 96",u:"https://www.bible.com/bible/59/PSA.96"},
{d:"0430",t:"Psalms 100",u:"https://www.bible.com/bible/59/PSA.100"},
{d:"0501",t:"Psalms 101",u:"https://www.bible.com/bible/59/PSA.101"},
{d:"0501",t:"Psalms 105",u:"https://www.bible.com/bible/59/PSA.105"},
{d:"0501",t:"Psalms 132",u:"https://www.bible.com/bible/59/PSA.132"},
{d:"0502",t:"2 Samuel 7",u:"https://www.bible.com/bible/59/2SA.7"},
{d:"0502",t:"Psalms 25",u:"https://www.bible.com/bible/59/PSA.25"},
{d:"0502",t:"Psalms 29",u:"https://www.bible.com/bible/59/PSA.29"},
{d:"0502",t:"Psalms 33",u:"https://www.bible.com/bible/59/PSA.33"},
{d:"0503",t:"2 Samuel 8-9",u:"https://www.bible.com/bible/59/2SA.8"},
{d:"0503",t:"Psalms 36",u:"https://www.bible.com/bible/59/PSA.36"},
{d:"0503",t:"Psalms 39",u:"https://www.bible.com/bible/59/PSA.39"},
{d:"0504",t:"Psalms 20",u:"https://www.bible.com/bible/59/PSA.20"},
{d:"0504",t:"Psalms 50",u:"https://www.bible.com/bible/59/PSA.50"},
{d:"0504",t:"Psalms 53",u:"https://www.bible.com/bible/59/PSA.53"},
{d:"0504",t:"Psalms 60",u:"https://www.bible.com/bible/59/PSA.60"},
{d:"0504",t:"Psalms 75",u:"https://www.bible.com/bible/59/PSA.75"},
{d:"0505",t:"2 Samuel 10",u:"https://www.bible.com/bible/59/2SA.10"},
{d:"0505",t:"Psalms 65-67",u:"https://www.bible.com/bible/59/PSA.65"},
{d:"0505",t:"Psalms 69-70",u:"https://www.bible.com/bible/59/PSA.69"},
{d:"0506",t:"2 Samuel 11-12",u:"https://www.bible.com/bible/59/2SA.11"},
{d:"0506",t:"Psalms 32",u:"https://www.bible.com/bible/59/PSA.32"},
{d:"0506",t:"Psalms 51",u:"https://www.bible.com/bible/59/PSA.51"},
{d:"0506",t:"Psalms 86",u:"https://www.bible.com/bible/59/PSA.86"},
{d:"0506",t:"Psalms 122",u:"https://www.bible.com/bible/59/PSA.122"},
{d:"0507",t:"2 Samuel 13-15",u:"https://www.bible.com/bible/59/2SA.13"},
{d:"0508",t:"Psalms 3-4",u:"https://www.bible.com/bible/59/PSA.3"},
{d:"0508",t:"Psalms 12-13",u:"https://www.bible.com/bible/59/PSA.12"},
{d:"0508",t:"Psalms 28",u:"https://www.bible.com/bible/59/PSA.28"},
{d:"0508",t:"Psalms 55",u:"https://www.bible.com/bible/59/PSA.55"},
{d:"0509",t:"2 Samuel 16-18",u:"https://www.bible.com/bible/59/2SA.16"},
{d:"0510",t:"Psalms 26",u:"https://www.bible.com/bible/59/PSA.26"},
{d:"0510",t:"Psalms 40",u:"https://www.bible.com/bible/59/PSA.40"},
{d:"0510",t:"Psalms 58",u:"https://www.bible.com/bible/59/PSA.58"},
{d:"0510",t:"Psalms 61-62",u:"https://www.bible.com/bible/59/PSA.61"},
{d:"0510",t:"Psalms 64",u:"https://www.bible.com/bible/59/PSA.64"},
{d:"0511",t:"2 Samuel 19-21",u:"https://www.bible.com/bible/59/2SA.19"},
{d:"0512",t:"Psalms 5",u:"https://www.bible.com/bible/59/PSA.5"},
{d:"0512",t:"Psalms 38",u:"https://www.bible.com/bible/59/PSA.38"},
{d:"0512",t:"Psalms 41-42",u:"https://www.bible.com/bible/59/PSA.41"},
{d:"0513",t:"2 Samuel 22-23",u:"https://www.bible.com/bible/59/2SA.22"},
{d:"0513",t:"Psalms 57",u:"https://www.bible.com/bible/59/PSA.57"},
{d:"0514",t:"Psalms 95",u:"https://www.bible.com/bible/59/PSA.95"},
{d:"0514",t:"Psalms 97-99",u:"https://www.bible.com/bible/59/PSA.97"},
{d:"0515",t:"2 Samuel 24",u:"https://www.bible.com/bible/59/2SA.24"},
{d:"0515",t:"Psalms 30",u:"https://www.bible.com/bible/59/PSA.30"},
{d:"0515",t:"Psalms 108-110",u:"https://www.bible.com/bible/59/PSA.108"},
{d:"0516",t:"Psalms 127",u:"https://www.bible.com/bible/59/PSA.127"},
{d:"0516",t:"Psalms 131",u:"https://www.bible.com/bible/59/PSA.131"},
{d:"0516",t:"Psalms 138-139",u:"https://www.bible.com/bible/59/PSA.138"},
{d:"0516",t:"Psalms 143-145",u:"https://www.bible.com/bible/59/PSA.143"},
{d:"0517",t:"Psalms 111-118",u:"https://www.bible.com/bible/59/PSA.111"},
{d:"0518",t:"1 Kings 1-2",u:"https://www.bible.com/bible/59/1KI.1"},
{d:"0519",t:"Psalms 37",u:"https://www.bible.com/bible/59/PSA.37"},
{d:"0519",t:"Psalms 71",u:"https://www.bible.com/bible/59/PSA.71"},
{d:"0519",t:"Psalms 94",u:"https://www.bible.com/bible/59/PSA.94"},
{d:"0520",t:"Psalms 119:1-88",u:"https://www.bible.com/bible/59/PSA.119.1"},
{d:"0521",t:"Psalms 119:89-176",u:"https://www.bible.com/bible/59/PSA.119.89"},
{d:"0522",t:"1 Kings 3-4",u:"https://www.bible.com/bible/59/1KI.3"},
{d:"0522",t:"Psalms 72",u:"https://www.bible.com/bible/59/PSA.72"},
{d:"0523",t:"Song of Solomon 1-8",u:"https://www.bible.com/bible/59/SNG.1"},
{d:"0524",t:"Proverbs 1-3",u:"https://www.bible.com/bible/59/PRO.1"},
{d:"0525",t:"Proverbs 4-6",u:"https://www.bible.com/bible/59/PRO.4"},
{d:"0526",t:"Proverbs 7-9",u:"https://www.bible.com/bible/59/PRO.7"},
{d:"0527",t:"Proverbs 10-12",u:"https://www.bible.com/bible/59/PRO.10"},
{d:"0528",t:"Proverbs 13-15",u:"https://www.bible.com/bible/59/PRO.13"},
{d:"0529",t:"Proverbs 16-18",u:"https://www.bible.com/bible/59/PRO.16"},
{d:"0530",t:"Proverbs 19-21",u:"https://www.bible.com/bible/59/PRO.19"},
{d:"0531",t:"Proverbs 22-24",u:"https://www.bible.com/bible/59/PRO.22"},
{d:"0601",t:"1 Kings 5-7",u:"https://www.bible.com/bible/59/1KI.5"},
{d:"0602",t:"1 Kings 8",u:"https://www.bible.com/bible/59/1KI.8"},
{d:"0602",t:"Psalms 136",u:"https://www.bible.com/bible/59/PSA.136"},
{d:"0603",t:"Psalms 134",u:"https://www.bible.com/bible/59/PSA.134"},
{d:"0603",t:"Psalms 146-150",u:"https://www.bible.com/bible/59/PSA.146"},
{d:"0604",t:"1 Kings 9",u:"https://www.bible.com/bible/59/1KI.9"},
{d:"0604",t:"Proverbs 25-26",u:"https://www.bible.com/bible/59/PRO.25"},
{d:"0605",t:"Proverbs 27-29",u:"https://www.bible.com/bible/59/PRO.27"},
{d:"0606",t:"Ecclesiastes 1-6",u:"https://www.bible.com/bible/59/ECC.1"},
{d:"0607",t:"Ecclesiastes 7-12",u:"https://www.bible.com/bible/59/ECC.7"},
{d:"0608",t:"1 Kings 10-11",u:"https://www.bible.com/bible/59/1KI.10"},
{d:"0609",t:"Proverbs 30-31",u:"https://www.bible.com/bible/59/PRO.30"},
{d:"0610",t:"1 Kings 12-14",u:"https://www.bible.com/bible/59/1KI.12"},
{d:"0611",t:"1 Kings 15-16",u:"https://www.bible.com/bible/59/1KI.15"},
{d:"0612",t:"1 Kings 17-19",u:"https://www.bible.com/bible/59/1KI.17"},
{d:"0613",t:"1 Kings 20-21",u:"https://www.bible.com/bible/59/1KI.20"},
{d:"0614",t:"1 Kings 22",u:"https://www.bible.com/bible/59/1KI.22"},
{d:"0615",t:"2 Kings 1-4",u:"https://www.bible.com/bible/59/2KI.1"},
{d:"0616",t:"2 Kings 5-8",u:"https://www.bible.com/bible/59/2KI.5"},
{d:"0617",t:"2 Kings 9-11",u:"https://www.bible.com/bible/59/2KI.9"},
{d:"0618",t:"2 Kings 12",u:"https://www.bible.com/bible/59/2KI.12"},
{d:"0618",t:"Joel 1-3",u:"https://www.bible.com/bible/59/JOL.1"},
{d:"0619",t:"2 Kings 13-14",u:"https://www.bible.com/bible/59/2KI.13"},
{d:"0619",t:"Jonah 1-4",u:"https://www.bible.com/bible/59/JON.1"},
{d:"0620",t:"2 Kings 15",u:"https://www.bible.com/bible/59/2KI.15"},
{d:"0621",t:"Isaiah 1-4",u:"https://www.bible.com/bible/59/ISA.1"},
{d:"0622",t:"Isaiah 5-8",u:"https://www.bible.com/bible/59/ISA.5"},
{d:"0623",t:"Amos 1-5",u:"https://www.bible.com/bible/59/AMO.1"},
{d:"0624",t:"Amos 6-9",u:"https://www.bible.com/bible/59/AMO.6"},
{d:"0625",t:"Isaiah 9-12",u:"https://www.bible.com/bible/59/ISA.9"},
{d:"0626",t:"Micah 1-7",u:"https://www.bible.com/bible/59/MIC.1"},
{d:"0627",t:"2 Kings 16-17",u:"https://www.bible.com/bible/59/2KI.16"},
{d:"0628",t:"Isaiah 13-17",u:"https://www.bible.com/bible/59/ISA.13"},
{d:"0629",t:"Isaiah 18-22",u:"https://www.bible.com/bible/59/ISA.18"},
{d:"0630",t:"Isaiah 23-27",u:"https://www.bible.com/bible/59/ISA.23"},
{d:"0701",t:"Hosea 1-7",u:"https://www.bible.com/bible/59/HOS.1"},
{d:"0702",t:"Hosea 8-14",u:"https://www.bible.com/bible/59/HOS.8"},
{d:"0703",t:"Isaiah 28-30",u:"https://www.bible.com/bible/59/ISA.28"},
{d:"0704",t:"Isaiah 31-35",u:"https://www.bible.com/bible/59/ISA.31"},
{d:"0705",t:"2 Kings 18-19",u:"https://www.bible.com/bible/59/2KI.18"},
{d:"0705",t:"Psalms 48",u:"https://www.bible.com/bible/59/PSA.48"},
{d:"0706",t:"Isaiah 36-37",u:"https://www.bible.com/bible/59/ISA.36"},
{d:"0707",t:"Isaiah 38-39",u:"https://www.bible.com/bible/59/ISA.38"},
{d:"0707",t:"Psalms 46",u:"https://www.bible.com/bible/59/PSA.46"},
{d:"0707",t:"Psalms 76",u:"https://www.bible.com/bible/59/PSA.76"},
{d:"0707",t:"Psalms 80",u:"https://www.bible.com/bible/59/PSA.80"},
{d:"0707",t:"Psalms 135",u:"https://www.bible.com/bible/59/PSA.135"},
{d:"0708",t:"Isaiah 40-43",u:"https://www.bible.com/bible/59/ISA.40"},
{d:"0709",t:"Isaiah 44-48",u:"https://www.bible.com/bible/59/ISA.44"},
{d:"0710",t:"Isaiah 49-53",u:"https://www.bible.com/bible/59/ISA.49"},
{d:"0711",t:"Isaiah 54-58",u:"https://www.bible.com/bible/59/ISA.54"},
{d:"0712",t:"Isaiah 59-63",u:"https://www.bible.com/bible/59/ISA.59"},
{d:"0713",t:"Isaiah 64-66",u:"https://www.bible.com/bible/59/ISA.64"},
{d:"0714",t:"2 Kings 20-21",u:"https://www.bible.com/bible/59/2KI.20"},
{d:"0715",t:"Nahum 1-3",u:"https://www.bible.com/bible/59/NAM.1"},
{d:"0716",t:"2 Kings 22-23",u:"https://www.bible.com/bible/59/2KI.22"},
{d:"0716",t:"Zephaniah 1-3",u:"https://www.bible.com/bible/59/ZEP.1"},
{d:"0717",t:"Jeremiah 1-3",u:"https://www.bible.com/bible/59/JER.1"},
{d:"0718",t:"Jeremiah 4-6",u:"https://www.bible.com/bible/59/JER.4"},
{d:"0719",t:"Jeremiah 7-9",u:"https://www.bible.com/bible/59/JER.7"},
{d:"0720",t:"Jeremiah 10-13",u:"https://www.bible.com/bible/59/JER.10"},
{d:"0721",t:"Jeremiah 14-17",u:"https://www.bible.com/bible/59/JER.14"},
{d:"0722",t:"Jeremiah 18-22",u:"https://www.bible.com/bible/59/JER.18"},
{d:"0723",t:"Jeremiah 23-25",u:"https://www.bible.com/bible/59/JER.23"},
{d:"0724",t:"Jeremiah 26-29",u:"https://www.bible.com/bible/59/JER.26"},
{d:"0725",t:"Jeremiah 30-31",u:"https://www.bible.com/bible/59/JER.30"},
{d:"0726",t:"Jeremiah 32-34",u:"https://www.bible.com/bible/59/JER.32"},
{d:"0727",t:"Jeremiah 35-37",u:"https://www.bible.com/bible/59/JER.35"},
{d:"0728",t:"Jeremiah 38-40",u:"https://www.bible.com/bible/59/JER.38"},
{d:"0728",t:"Psalms 74",u:"https://www.bible.com/bible/59/PSA.74"},
{d:"0728",t:"Psalms 79",u:"https://www.bible.com/bible/59/PSA.79"},
{d:"0729",t:"2 Kings 24-25",u:"https://www.bible.com/bible/59/2KI.24"},
{d:"0729",t:"Obadiah 1",u:"https://www.bible.com/bible/59/OBA.1"},
{d:"0729",t:"Psalms 82-83",u:"https://www.bible.com/bible/59/PSA.82"},
{d:"0730",t:"Habakkuk 1-3",u:"https://www.bible.com/bible/59/HAB.1"},
{d:"0731",t:"Jeremiah 41-45",u:"https://www.bible.com/bible/59/JER.41"},
{d:"0801",t:"Jeremiah 46-48",u:"https://www.bible.com/bible/59/JER.46"},
{d:"0802",t:"Jeremiah 49-50",u:"https://www.bible.com/bible/59/JER.49"},
{d:"0803",t:"Jeremiah 51-52",u:"https://www.bible.com/bible/59/JER.51"},
{d:"0804",t:"Lamentations 1:1-3:36",u:"https://www.bible.com/bible/59/LAM.1.1"},
{d:"0805",t:"Lamentations 3:37-5:22",u:"https://www.bible.com/bible/59/LAM.3.37"},
{d:"0806",t:"Ezekiel 1-4",u:"https://www.bible.com/bible/59/EZK.1"},
{d:"0807",t:"Ezekiel 5-8",u:"https://www.bible.com/bible/59/EZK.5"},
{d:"0808",t:"Ezekiel 9-12",u:"https://www.bible.com/bible/59/EZK.9"},
{d:"0809",t:"Ezekiel 13-15",u:"https://www.bible.com/bible/59/EZK.13"},
{d:"0810",t:"Ezekiel 16-17",u:"https://www.bible.com/bible/59/EZK.16"},
{d:"0811",t:"Ezekiel 18-19",u:"https://www.bible.com/bible/59/EZK.18"},
{d:"0812",t:"Ezekiel 20-21",u:"https://www.bible.com/bible/59/EZK.20"},
{d:"0813",t:"Ezekiel 22-23",u:"https://www.bible.com/bible/59/EZK.22"},
{d:"0814",t:"Ezekiel 24-27",u:"https://www.bible.com/bible/59/EZK.24"},
{d:"0815",t:"Ezekiel 28-31",u:"https://www.bible.com/bible/59/EZK.28"},
{d:"0816",t:"Ezekiel 32-34",u:"https://www.bible.com/bible/59/EZK.32"},
{d:"0817",t:"Ezekiel 35-37",u:"https://www.bible.com/bible/59/EZK.35"},
{d:"0818",t:"Ezekiel 38-39",u:"https://www.bible.com/bible/59/EZK.38"},
{d:"0819",t:"Ezekiel 40-41",u:"https://www.bible.com/bible/59/EZK.40"},
{d:"0820",t:"Ezekiel 42-43",u:"https://www.bible.com/bible/59/EZK.42"},
{d:"0821",t:"Ezekiel 44-45",u:"https://www.bible.com/bible/59/EZK.44"},
{d:"0822",t:"Ezekiel 46-48",u:"https://www.bible.com/bible/59/EZK.46"},
{d:"0823",t:"Daniel 1-3",u:"https://www.bible.com/bible/59/DAN.1"},
{d:"0824",t:"Daniel 4-6",u:"https://www.bible.com/bible/59/DAN.4"},
{d:"0825",t:"Daniel 7-9",u:"https://www.bible.com/bible/59/DAN.7"},
{d:"0826",t:"Daniel 10-12",u:"https://www.bible.com/bible/59/DAN.10"},
{d:"0827",t:"1 Chronicles 1-2",u:"https://www.bible.com/bible/59/1CH.1"},
{d:"0828",t:"1 Chronicles 3-5",u:"https://www.bible.com/bible/59/1CH.3"},
{d:"0829",t:"1 Chronicles 6",u:"https://www.bible.com/bible/59/1CH.6"},
{d:"0830",t:"1 Chronicles 7-9",u:"https://www.bible.com/bible/59/1CH.7"},
{d:"0831",t:"1 Chronicles 10-12",u:"https://www.bible.com/bible/59/1CH.10"},
{d:"0901",t:"1 Chronicles 13-16",u:"https://www.bible.com/bible/59/1CH.13"},
{d:"0902",t:"1 Chronicles 17-20",u:"https://www.bible.com/bible/59/1CH.17"},
{d:"0903",t:"1 Chronicles 21-23",u:"https://www.bible.com/bible/59/1CH.21"},
{d:"0904",t:"1 Chronicles 24-26",u:"https://www.bible.com/bible/59/1CH.24"},
{d:"0905",t:"1 Chronicles 27-29",u:"https://www.bible.com/bible/59/1CH.27"},
{d:"0906",t:"2 Chronicles 1-3",u:"https://www.bible.com/bible/59/2CH.1"},
{d:"0907",t:"2 Chronicles 4-6",u:"https://www.bible.com/bible/59/2CH.4"},
{d:"0908",t:"2 Chronicles 7-9",u:"https://www.bible.com/bible/59/2CH.7"},
{d:"0909",t:"2 Chronicles 10-12",u:"https://www.bible.com/bible/59/2CH.10"},
{d:"0910",t:"2 Chronicles 13-15",u:"https://www.bible.com/bible/59/2CH.13"},
{d:"0911",t:"2 Chronicles 16-18",u:"https://www.bible.com/bible/59/2CH.16"},
{d:"0912",t:"2 Chronicles 19-21",u:"https://www.bible.com/bible/59/2CH.19"},
{d:"0913",t:"2 Chronicles 22-24",u:"https://www.bible.com/bible/59/2CH.22"},
{d:"0914",t:"2 Chronicles 25-27",u:"https://www.bible.com/bible/59/2CH.25"},
{d:"0915",t:"2 Chronicles 28-30",u:"https://www.bible.com/bible/59/2CH.28"},
{d:"0916",t:"2 Chronicles 31-33",u:"https://www.bible.com/bible/59/2CH.31"},
{d:"0917",t:"2 Chronicles 34-36",u:"https://www.bible.com/bible/59/2CH.34"},
{d:"0918",t:"Ezra 1-3",u:"https://www.bible.com/bible/59/EZR.1"},
{d:"0919",t:"Ezra 4-6",u:"https://www.bible.com/bible/59/EZR.4"},
{d:"0919",t:"Psalms 137",u:"https://www.bible.com/bible/59/PSA.137"},
{d:"0920",t:"Haggai 1-2",u:"https://www.bible.com/bible/59/HAG.1"},
{d:"0921",t:"Zechariah 1-7",u:"https://www.bible.com/bible/59/ZEC.1"},
{d:"0922",t:"Zechariah 8-14",u:"https://www.bible.com/bible/59/ZEC.8"},
{d:"0923",t:"Esther 1-5",u:"https://www.bible.com/bible/59/EST.1"},
{d:"0924",t:"Esther 6-10",u:"https://www.bible.com/bible/59/EST.6"},
{d:"0925",t:"Ezra 7-10",u:"https://www.bible.com/bible/59/EZR.7"},
{d:"0926",t:"Nehemiah 1-5",u:"https://www.bible.com/bible/59/NEH.1"},
{d:"0927",t:"Nehemiah 6-7",u:"https://www.bible.com/bible/59/NEH.6"},
{d:"0928",t:"Nehemiah 8-10",u:"https://www.bible.com/bible/59/NEH.8"},
{d:"0929",t:"Nehemiah 11-13",u:"https://www.bible.com/bible/59/NEH.11"},
{d:"0929",t:"Psalms 126",u:"https://www.bible.com/bible/59/PSA.126"},
{d:"0930",t:"Malachi 1-4",u:"https://www.bible.com/bible/59/MAL.1"},
{d:"1001",t:"Matthew 1-3",u:"https://www.bible.com/bible/59/MAT.1"},
{d:"1002",t:"Matthew 4-5",u:"https://www.bible.com/bible/59/MAT.4"},
{d:"1003",t:"Matthew 6-7",u:"https://www.bible.com/bible/59/MAT.6"},
{d:"1004",t:"Matthew 8-9",u:"https://www.bible.com/bible/59/MAT.8"},
{d:"1005",t:"Matthew 10-11",u:"https://www.bible.com/bible/59/MAT.10"},
{d:"1006",t:"Matthew 12-13",u:"https://www.bible.com/bible/59/MAT.12"},
{d:"1007",t:"Matthew 14-15",u:"https://www.bible.com/bible/59/MAT.14"},
{d:"1008",t:"Matthew 16-17",u:"https://www.bible.com/bible/59/MAT.16"},
{d:"1009",t:"Matthew 18-19",u:"https://www.bible.com/bible/59/MAT.18"},
{d:"1010",t:"Matthew 20-21",u:"https://www.bible.com/bible/59/MAT.20"},
{d:"1011",t:"Matthew 22-23",u:"https://www.bible.com/bible/59/MAT.22"},
{d:"1012",t:"Matthew 24-25",u:"https://www.bible.com/bible/59/MAT.24"},
{d:"1013",t:"Matthew 26",u:"https://www.bible.com/bible/59/MAT.26"},
{d:"1014",t:"Matthew 27-28",u:"https://www.bible.com/bible/59/MAT.27"},
{d:"1015",t:"Mark 1-2",u:"https://www.bible.com/bible/59/MRK.1"},
{d:"1016",t:"Mark 3-4",u:"https://www.bible.com/bible/59/MRK.3"},
{d:"1017",t:"Mark 5-6",u:"https://www.bible.com/bible/59/MRK.5"},
{d:"1018",t:"Mark 7-8",u:"https://www.bible.com/bible/59/MRK.7"},
{d:"1019",t:"Mark 9-10",u:"https://www.bible.com/bible/59/MRK.9"},
{d:"1020",t:"Mark 11-12",u:"https://www.bible.com/bible/59/MRK.11"},
{d:"1021",t:"Mark 13-14",u:"https://www.bible.com/bible/59/MRK.13"},
{d:"1022",t:"Mark 15-16",u:"https://www.bible.com/bible/59/MRK.15"},
{d:"1023",t:"Luke 1",u:"https://www.bible.com/bible/59/LUK.1"},
{d:"1024",t:"Luke 2-3",u:"https://www.bible.com/bible/59/LUK.2"},
{d:"1025",t:"Luke 4-5",u:"https://www.bible.com/bible/59/LUK.4"},
{d:"1026",t:"Luke 6-7",u:"https://www.bible.com/bible/59/LUK.6"},
{d:"1027",t:"Luke 8-9",u:"https://www.bible.com/bible/59/LUK.8"},
{d:"1028",t:"Luke 10-11",u:"https://www.bible.com/bible/59/LUK.10"},
{d:"1029",t:"Luke 12-13",u:"https://www.bible.com/bible/59/LUK.12"},
{d:"1030",t:"Luke 14-15",u:"https://www.bible.com/bible/59/LUK.14"},
{d:"1031",t:"Luke 16-17",u:"https://www.bible.com/bible/59/LUK.16"},
{d:"1101",t:"Luke 18-19",u:"https://www.bible.com/bible/59/LUK.18"},
{d:"1102",t:"Luke 20-21",u:"https://www.bible.com/bible/59/LUK.20"},
{d:"1103",t:"Luke 22",u:"https://www.bible.com/bible/59/LUK.22"},
{d:"1104",t:"Luke 23-24",u:"https://www.bible.com/bible/59/LUK.23"},
{d:"1105",t:"Acts 1-3",u:"https://www.bible.com/bible/59/ACT.1"},
{d:"1106",t:"Acts 4-6",u:"https://www.bible.com/bible/59/ACT.4"},
{d:"1107",t:"Acts 7-8",u:"https://www.bible.com/bible/59/ACT.7"},
{d:"1108",t:"Acts 9-10",u:"https://www.bible.com/bible/59/ACT.9"},
{d:"1109",t:"Acts 11-12",u:"https://www.bible.com/bible/59/ACT.11"},
{d:"1110",t:"Acts 13-14",u:"https://www.bible.com/bible/59/ACT.13"},
{d:"1111",t:"James 1-5",u:"https://www.bible.com/bible/59/JAS.1"},
{d:"1112",t:"Acts 15-16",u:"https://www.bible.com/bible/59/ACT.15"},
{d:"1113",t:"Galatians 1-3",u:"https://www.bible.com/bible/59/GAL.1"},
{d:"1114",t:"Galatians 4-6",u:"https://www.bible.com/bible/59/GAL.4"},
{d:"1115",t:"Acts 17-18:18",u:"https://www.bible.com/bible/59/ACT.17"},
{d:"1116",t:"1 Thessalonians 1-5",u:"https://www.bible.com/bible/59/1TH.1"},
{d:"1116",t:"2 Thessalonians 1-3",u:"https://www.bible.com/bible/59/2TH.1"},
{d:"1117",t:"Acts 18:19-19:41",u:"https://www.bible.com/bible/59/ACT.18.19"},
{d:"1118",t:"1 Corinthians 1-4",u:"https://www.bible.com/bible/59/1CO.1"},
{d:"1119",t:"1 Corinthians 5-8",u:"https://www.bible.com/bible/59/1CO.5"},
{d:"1120",t:"1 Corinthians 9-11",u:"https://www.bible.com/bible/59/1CO.9"},
{d:"1121",t:"1 Corinthians 12-14",u:"https://www.bible.com/bible/59/1CO.12"},
{d:"1122",t:"1 Corinthians 15-16",u:"https://www.bible.com/bible/59/1CO.15"},
{d:"1123",t:"2 Corinthians 1-4",u:"https://www.bible.com/bible/59/2CO.1"},
{d:"1124",t:"2 Corinthians 5-9",u:"https://www.bible.com/bible/59/2CO.5"},
{d:"1125",t:"2 Corinthians 10-13",u:"https://www.bible.com/bible/59/2CO.10"},
{d:"1126",t:"Romans 1-3",u:"https://www.bible.com/bible/59/ROM.1"},
{d:"1127",t:"Romans 4-7",u:"https://www.bible.com/bible/59/ROM.4"},
{d:"1128",t:"Romans 8-10",u:"https://www.bible.com/bible/59/ROM.8"},
{d:"1129",t:"Romans 11-13",u:"https://www.bible.com/bible/59/ROM.11"},
{d:"1130",t:"Romans 14-16",u:"https://www.bible.com/bible/59/ROM.14"},
{d:"1201",t:"Acts 20-23",u:"https://www.bible.com/bible/59/ACT.20"},
{d:"1202",t:"Acts 24-26",u:"https://www.bible.com/bible/59/ACT.24"},
{d:"1203",t:"Acts 27-28",u:"https://www.bible.com/bible/59/ACT.27"},
{d:"1204",t:"Colossians 1-4",u:"https://www.bible.com/bible/59/COL.1"},
{d:"1204",t:"Philemon 1",u:"https://www.bible.com/bible/59/PHM.1"},
{d:"1205",t:"Ephesians 1-6",u:"https://www.bible.com/bible/59/EPH.1"},
{d:"1206",t:"Philippians 1-4",u:"https://www.bible.com/bible/59/PHP.1"},
{d:"1207",t:"1 Timothy 1-6",u:"https://www.bible.com/bible/59/1TI.1"},
{d:"1208",t:"Titus 1-3",u:"https://www.bible.com/bible/59/TIT.1"},
{d:"1209",t:"1 Peter 1-5",u:"https://www.bible.com/bible/59/1PE.1"},
{d:"1210",t:"Hebrews 1-6",u:"https://www.bible.com/bible/59/HEB.1"},
{d:"1211",t:"Hebrews 7-10",u:"https://www.bible.com/bible/59/HEB.7"},
{d:"1212",t:"Hebrews 11-13",u:"https://www.bible.com/bible/59/HEB.11"},
{d:"1213",t:"2 Timothy 1-4",u:"https://www.bible.com/bible/59/2TI.1"},
{d:"1214",t:"2 Peter 1-3",u:"https://www.bible.com/bible/59/2PE.1"},
{d:"1214",t:"Jude 1",u:"https://www.bible.com/bible/59/JUD.1"},
{d:"1215",t:"John 1-2",u:"https://www.bible.com/bible/59/JHN.1"},
{d:"1216",t:"John 3-4",u:"https://www.bible.com/bible/59/JHN.3"},
{d:"1217",t:"John 5",u:"https://www.bible.com/bible/59/JHN.5"},
{d:"1218",t:"John 6",u:"https://www.bible.com/bible/59/JHN.6"},
{d:"1219",t:"John 7",u:"https://www.bible.com/bible/59/JHN.7"},
{d:"1220",t:"John 8",u:"https://www.bible.com/bible/59/JHN.8"},
{d:"1221",t:"John 9-10",u:"https://www.bible.com/bible/59/JHN.9"},
{d:"1222",t:"John 11-12",u:"https://www.bible.com/bible/59/JHN.11"},
{d:"1223",t:"John 13-15",u:"https://www.bible.com/bible/59/JHN.13"},
{d:"1224",t:"John 16-18",u:"https://www.bible.com/bible/59/JHN.16"},
{d:"1225",t:"John 19-21",u:"https://www.bible.com/bible/59/JHN.19"},
{d:"1226",t:"1 John 1-5",u:"https://www.bible.com/bible/59/1JN.1"},
{d:"1227",t:"2 John 1",u:"https://www.bible.com/bible/59/2JN.1"},
{d:"1227",t:"3 John 1",u:"https://www.bible.com/bible/59/3JN.1"},
{d:"1228",t:"Revelation 1-5",u:"https://www.bible.com/bible/59/REV.1"},
{d:"1229",t:"Revelation 6-11",u:"https://www.bible.com/bible/59/REV.6"},
{d:"1230",t:"Revelation 12-18",u:"https://www.bible.com/bible/59/REV.12"},
{d:"1231",t:"Revelation 19-22",u:"https://www.bible.com/bible/59/REV.19"},
];
